/** JavaScript SOAP Client

 This library consists of 2 objects:
 SOAPClient - a SOAP transport mechanism to send/receive SOAP envelopes.
 SOAPRequest - an object that represents a SOAP Envelope. This is the object to create when you want to send a request to the SOAP Web Service.

 Effectively you may create a single SOAPClient instance and use multiple SOAPRequest instances to push through the SOAPClient.

 */
define('soap/soap',['require','exports','module','xml/xml','bindable/jquery.bindable'],function (require, exports, module) {
    "use strict";
    //Load dependent libs

    var xml = require('xml/xml');
    var bindable = require('bindable/jquery.bindable');

    var
        SOAPClient = function (conf, req) {
            this.settings = {
                proxy:null,
                ws:null,
                contentType:'text/xml',
                charSet:'utf-8',
                type:'post'
            };
            this.events = {
                onSOAPResponse:"onSOAPResponse",
                onSOAPError:"onSOAPError"
            };
            this.request = req || null;
            if (conf) $.extend(this.settings, conf);
        },

        SOAPRequest = function (conf, body) {
            var that = this;
            this.settings = {
                action:'',
                ns:{}
            };
            this.envelope = {
                "soapenv:Body":{}
            };
            if (conf) $.extend(this.settings, conf);
            //Set additional namespaces for envelope
            if (typeof(this.settings.ns) === "string") {
                this.envelope["@xmlns"] = this.settings.ns;
            } else {
                $.each(this.settings.ns, function (n, u) {
                    that.envelope["@xmlns:" + n] = u;
                });
            }

            if (body) this.addToBody(body);
        };

    SOAPClient.prototype = {
        sendRequest:function (req) {
            this.request = req || this.request;
            if (this.request) {
                var that = this,
                    conf = this.settings,
                    request = this.request,
                    response, data = request.toString(),
                    def = new $.Deferred();

                $.ajax({
                    type:conf.type,
                    url:conf.proxy || conf.ws,
                    dataType:"xml",
                    contentType:conf.contentType + "; charset=\"" + conf.charSet + "\"",
                    processData:false,
                    data:data,
                    beforeSend:function (xhr) {
                        xhr.setRequestHeader("Method", conf.type);
                        xhr.setRequestHeader("SOAPServer", conf.ws);
                        xhr.setRequestHeader("SOAPAction", request.settings.action);
                    },
                    complete:function (jqXHR, textStatus) {
                        response = xml.xmlToJSON(jqXHR.responseXML || jqXHR.responseText);
                        if (textStatus == "success") {
                            def.resolve(response);
                            that.trigger(that.events.onSOAPResponse, response);
                        } else {
                            def.reject(response);
                            that.trigger(that.events.onSOAPError, arguments);
                        }
                    }
                });

                return def.promise();
            }
        }
    };

    bindable(SOAPClient);

    SOAPRequest.prototype = {
        addHeader:function (obj) {
            if (!this.envelope["soapenv:Header"]) {
                this.envelope["soapenv:Header"] = {};
            }
            if (obj) $.extend(this.envelope["soapenv:Header"], obj);
            return this;
        },
        addToBody:function (obj) {
            if (obj) $.extend(this.envelope["soapenv:Body"], obj);
            return this;
        },
        toString:function () {
            return xml.jsonToXML("soapenv:Envelope", "http://schemas.xmlsoap.org/soap/envelope/", this.envelope);
        }
    };

    exports.SOAPClient = SOAPClient;
    exports.SOAPRequest = SOAPRequest;

});


